module.exports = __webpack_public_path__ + "fonts/ofont.ru_Helvetica Neue.7a242cbe.ttf";